import type { ReactNode } from "react";

import cc from "classcat";

import styles from "./PanelCard.module.scss";

interface PanelCardProps {
  children: ReactNode;
  testId?: string;
}

/** The card every section of the details panel sits in. */
const PanelCard = ({ children, testId }: PanelCardProps) => (
  <div
    className={cc([
      styles.card,
      "border--all",
      "rounded--all--l",
      "padding--all--l",
    ])}
    data-testid={testId}
  >
    {children}
  </div>
);

export default PanelCard;
